import { createGlobalStyle } from 'styled-components';
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
export const GlobalStyle = createGlobalStyle`
    :root {
        --theme: #1890ff;
        --dominant: #FBB634;
        --copigment: #E28D32;
        --accent: #A14D22;
    }
    .show {
        display: block !important;
    }
    .hide {
        display: none !important;
    }
    .action-button {
      background-color: transparent;
      vertical-align: middle;
      padding: 0;
      margin: 0;
      position: static;
      border: 0;
      border-radius: 0;
      color: inherit;
      cursor: pointer;
      i {
        display: block;
      }
    }
    .action-user {
      font-size: 36px;
      color: #188efc;
    }
    .action-role {
      font-size: 36px;
      color: orange;
    }
    .action-permission {
      font-size: 36px;
      color: #53c41a;
    }
    .action-show {
      font-size: 36px;
      color: #188efc;
    }
    .action-edit {
      font-size: 36px;
      color: #a14d22;
    }
    .action-delete {
      font-size: 36px;
      color: #f5212d;
    }
    
    .operation-span {
        font-size: 16px;
    }
    
`;



